import { render, staticRenderFns } from "./FormSignUp.vue?vue&type=template&id=595eb2e8&"
import script from "./FormSignUp.vue?vue&type=script&lang=js&"
export * from "./FormSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports